export default __webpack_public_path__ + "images/chakkeb-al-bac-icon.svg";